import { legacyFilePath } from "./utils/legacyFilePaths";
const envValue = process.env.REACT_APP_USE_WEBCRYPTO;
const useWebCrypto = (envValue === undefined || envValue === 'undefined' || envValue === "true" || envValue === true  );
const url = new URL(window.location.href);
const autoDefaultURL =  `${url.origin}/elakay_api`
const env = (name, fallback = "") => {
  const value = process.env[name];
  return value === undefined || value === null || value === "undefined" ? fallback : value;
};

export const password = env("REACT_APP_DECRYPTO_ENCRYPTO_ELAKAY")
export const elakay_API1 = env("REACT_APP_API_URL_", autoDefaultURL)
export const elakay_API = useWebCrypto ? env("REACT_APP_API_URL", elakay_API1) : elakay_API1
export const REACT_PK = env("REACT_APP_STRIPE_KEY")
export const ELAKAY_URl = env("REACT_APP_ELAKAY_URL")

const LOOPBACK_HOSTNAMES = new Set(["localhost", "127.0.0.1", "0.0.0.0", "[::1]"]);
const parseHttpUrl = (value) => {
  try {
    const parsed = new URL(String(value || "").trim());
    return parsed.protocol === "http:" || parsed.protocol === "https:" ? parsed : null;
  } catch (err) {
    return null;
  }
};

/**
 * Public base URL of the Elakay frontend (no trailing slash): the base of
 * every link handed to someone else -- QR codes, promotion / Event World
 * tokens, /user_Shoosing and /user-step links, the "back to Elakay" button.
 * Source: REACT_APP_ELAKAY_URL (inlined at build time).
 *
 * A link shared from a public host must never point to this machine: when the
 * variable is missing or invalid, or is a loopback address while the app is
 * served from a real host (a build made with the local .env), the origin the
 * app is actually served from is used and the misconfiguration is reported.
 * API requests never use this value (see elakay_API).
 *
 * @param {String} [configured] defaults to REACT_APP_ELAKAY_URL
 * @param {String} [browserOrigin] defaults to the current page origin
 */
export function resolveElakaySiteUrl(configured, browserOrigin = url.origin) {
  // No argument means "resolve the app configuration". Passing undefined
  // explicitly is treated as a missing value, which is useful to validate a
  // deployment configuration without silently re-reading the global value.
  const configuredValue = arguments.length === 0 ? ELAKAY_URl : configured;
  const site = parseHttpUrl(configuredValue);
  const page = parseHttpUrl(browserOrigin);
  const pageIsPublic = Boolean(page) && !LOOPBACK_HOSTNAMES.has(page.hostname);
  if (site && !(LOOPBACK_HOSTNAMES.has(site.hostname) && pageIsPublic)) {
    return `${site.origin}${site.pathname.replace(/\/+$/, "")}`;
  }
  const fallback = page ? page.origin : "";
  console.error(
    `[Elakay config] REACT_APP_ELAKAY_URL is ${site ? `"${site.origin}" (a local address)` : "missing or invalid"}` +
    ` in this build; public links use "${fallback}" instead. Set REACT_APP_ELAKAY_URL and rebuild the frontend.`
  );
  return fallback;
}

export const ELAKAY_SITE_URL = resolveElakaySiteUrl()
// Legacy name, kept for its importers. It used to be a hard-coded
// "http://localhost:3000", which every QR code / promotion link generated in
// production then carried.
export const ELAKAY_URl1 = ELAKAY_SITE_URL

/**
 * Absolute public URL for a link built by the API (e.g. activation.shareUrl,
 * built from the server's URL_ELAKAY): a relative path, or a URL on a local
 * address while this app runs on a public host, is moved onto the site URL.
 * Path, query and token are kept exactly; any other URL is returned as is.
 */
export const toElakaySiteUrl = (link, siteUrl = ELAKAY_SITE_URL) => {
  if (!link || typeof link !== "string") return "";
  const site = parseHttpUrl(siteUrl);
  if (!site) return link;
  const siteBase = `${site.origin}${site.pathname.replace(/\/+$/, "")}`;
  if (link.startsWith("/") && !link.startsWith("//")) return `${siteBase}${link}`;
  const parsed = parseHttpUrl(link);
  if (!parsed || !LOOPBACK_HOSTNAMES.has(parsed.hostname) || LOOPBACK_HOSTNAMES.has(site.hostname)) return link;
  return `${siteBase}${parsed.pathname}${parsed.search}${parsed.hash}`;
};
export const FirtIDCategory =  env("REACT_APP_FirtID_Category", "5ed4946fd2ba8812c20261a8")

export const normalizeUrl = (inputUrl) =>{
  try {
    // Convertir en objet URL
    const url = new URL(inputUrl);

    // Si le host de l'URL ≠ host actuel
    if (url.hostname !== window.location.hostname) {
      url.hostname = window.location.hostname;
    }

    return url.toString();
  } catch (err) {
    console.error("URL invalide :", inputUrl, err);
    return null;
  }
}

// Host de l'API courante (elakay_API peut être relatif ou absolu selon la config).
const apiOrigin = () => {
  try {
    return new URL(elakay_API, window.location.origin).origin;
  } catch (err) {
    return window.location.origin;
  }
};

/**
 * Rebase toute URL Elakay-hébergée (/elakay_api/...) sur l'origine API
 * courante, qu'elle soit déjà relative ou qu'elle traîne un ancien host figé
 * en base (ex: http://localhost:2284/elakay_api/image-assets/... enregistré
 * par une migration Buffer -> ImageAsset lancée dans un autre environnement).
 * Les URLs externes (CDN dropshipping, etc.) ne contiennent pas "/elakay_api/"
 * et ressortent donc inchangées.
 */
export const  toImageUrl = (url, imagePath) =>{
    if (!url || typeof url !== "string") return url;
    const marker = "/elakay_api/";
    const idx = url.indexOf(marker);
    if (idx === -1) {
      // Historical upload URLs (/media/..., /data/images/...) never reached
      // the API in production: map them to /elakay_api/files/<zone>/<name>.
      // Only relative paths and Elakay / loopback hosts.
      try {
        const relative = url.startsWith("/") && !url.startsWith("//");
        const parsed = new URL(url, window.location.origin);
        const host = parsed.hostname.toLowerCase();
        const elakayHost = relative || ["localhost", "127.0.0.1"].includes(host) || host === "elakay.com" || host.endsWith(".elakay.com");
        const mapped = elakayHost ? legacyFilePath(parsed.pathname) : null;
        return mapped ? `${apiOrigin()}${mapped}${parsed.search}` : url;
      } catch (err) {
        return url;
      }
    }
    return `${apiOrigin()}${url.slice(idx)}`;
}

/**
 * Same rebase as toImageUrl(), applied to every <img src="..."> occurrence
 * inside a full HTML *string* -- for VIEWING surfaces only (the Email
 * Marketing Preview iframe), never for the literal HTML Source text or the
 * HTML actually sent to Mailgun. A server-resolved product/asset image is
 * legitimately rewritten to a real public host at resolution time
 * (sanitizeImageUrlForEmail(), server-side) so a SENT email never links to
 * localhost -- correct for a real recipient, but that public host may not
 * serve THIS environment's own locally-uploaded images (e.g. local dev
 * test data never pushed to production), which would otherwise render as
 * a broken image in the Preview only, even though the exact same product
 * displays fine in Select Content / the Build Email canvas (both already
 * apply this same toImageUrl() rebase). A no-op in production (the API
 * origin already IS the public host) and for any src with no "/elakay_api/"
 * marker (external CDN/dropshipping images pass through unchanged).
 */
export const rebaseEmailAssetUrlsForPreview = (html) => {
  if (!html || typeof html !== "string") return html;
  return html.replace(/(<img\b[^>]*\bsrc=")([^"]*)(")/gi, (match, prefix, url, suffix) => `${prefix}${toImageUrl(url)}${suffix}`);
};

const IMAGE_LOAD_ALLOWED_WIDTHS = [96, 120, 160, 256, 300, 320, 400, 480, 600, 640, 768, 800, 900, 960, 1200, 1280, 1600, 1800, 1920];

// Recognizes an Elakay-hosted image route -- one that is already directly
// loadable (or, for /img-load, already an optimized wrapper) and never needs
// its own URL reconstructed from scratch. Shared by getElakayImageLoadUrl()
// (host/prefix guard before proxying) and isDirectElakayImageUrl() (the
// front's own "do we already have a final URL?" check).
const ELAKAY_API_ROUTE_PATTERN = /\/elakay_api\/(img|pubCi|pubR|image-assets|img-load)(\/|\?|$)/;

const parseAgainstApi = (normalizedUrl) => {
  try {
    return {
      parsedUrl: new URL(normalizedUrl, window.location.origin),
      parsedApiUrl: new URL(elakay_API, window.location.origin),
    };
  } catch (e) {
    return null;
  }
};

/**
 * True when `url` is already a final, directly-loadable Elakay image URL --
 * one of /elakay_api/img/, /pubCi/, /pubR/, /image-assets/ (or /img-load,
 * already optimized), absolute or relative, current host or a stale one
 * toImageUrl() would rebase. Such a URL must be used as-is, never rebuilt
 * from a productId/categoryId, and never wrapped in /img-load by default --
 * see resolveCategoryImageUrl() and getProductImageUrls() (elakay-utils.jsx),
 * which both stop here before falling back to a constructed legacy URL.
 * An external supplier CDN URL (CJ dropshipping, etc.) is not "Elakay direct"
 * -- it returns false here but remains perfectly valid to display as-is.
 */
export const isDirectElakayImageUrl = (url) => {
  if (!url || typeof url !== "string") return false;
  const normalizedUrl = toImageUrl(url);
  if (!normalizedUrl) return false;
  const parsed = parseAgainstApi(normalizedUrl);
  if (!parsed) return false;
  const { parsedUrl, parsedApiUrl } = parsed;
  return parsedUrl.host === parsedApiUrl.host && ELAKAY_API_ROUTE_PATTERN.test(parsedUrl.pathname + parsedUrl.search);
};

/**
 * Routes an existing image URL (e.g. product/category/avatar urlImg) through
 * the backend's resize/cache proxy (GET /elakay_api/img-load) instead of
 * loading the full-size original. Never touches urlImg itself — purely a
 * display-time transform, and purely OPTIONAL: it is only ever applied on
 * top of a URL a resolver (resolveCategoryImageUrl, getProductImageUrls, ...)
 * already picked -- never used to build that URL in the first place, and
 * never required for the image to display (every caller's onError/fallback
 * path already degrades to the un-optimized direct URL or a placeholder).
 *
 * Usage: ProductGrid/Gallery width=300, ProductDetail/Banner width=900,
 * Avatar/Order table width=120.
 *
 * @param {String} inputUrl the original image URL — rebased through
 *   toImageUrl() internally, so a raw DB value (stale host, localhost,
 *   relative path) works whether or not the caller already normalized it.
 * @param {Object} options
 * @param {Number} options.width one of 120/300/600/900 (snapped to nearest allowed value)
 * @param {Number} [options.quality] 60/70/80, defaults to the backend's IMAGE_DEFAULT_QUALITY
 * @param {'webp'|'jpg'|'png'} [options.format] defaults to webp
 */
export const getElakayImageLoadUrl = (inputUrl, { width = 300, quality, format = "webp" } = {}) => {
  if (!inputUrl || typeof inputUrl !== "string") return inputUrl;

  const normalizedUrl = toImageUrl(inputUrl);
  if (!normalizedUrl || typeof normalizedUrl !== "string") return normalizedUrl;

  // Never break an existing working image: if the URL can't be parsed,
  // fall back to it unchanged rather than building a broken proxy URL.
  const parsed = parseAgainstApi(normalizedUrl);
  if (!parsed) return normalizedUrl;
  const { parsedUrl: parsedImageUrl, parsedApiUrl } = parsed;

  // /img-load only accepts Elakay-hosted sources to prevent SSRF. Supplier
  // images (CJ, Printful, etc.) are already public HTTPS assets, so sending
  // them through that endpoint always returns 400 and leaves the product
  // gallery empty. Load those CDN URLs directly.
  if (parsedImageUrl.host !== parsedApiUrl.host) return normalizedUrl;

  // Only proxy actual Elakay-served resources (/elakay_api/..., or an
  // uploaded file at the root: /media/..., /data/images/...) — never a
  // same-host URL that happens to sit outside those prefixes. In production
  // the API and the site share one host, so the app's own bundled assets
  // (/static/media/...) reach this point: /img-load refuses them (400).
  if (!/^\/(?:media\/|data\/images\/)|\/elakay_api\//.test(parsedImageUrl.pathname)) return normalizedUrl;

  // Avoid nesting (img-load?src=.../img-load?src=...): if we were handed an
  // already-optimized URL, unwrap its own "src" and rebuild a single proxy
  // URL from that instead of wrapping it again.
  let sourceUrl = normalizedUrl;
  if (parsedImageUrl.pathname.endsWith("/img-load")) {
    const innerSrc = parsedImageUrl.searchParams.get("src");
    if (!innerSrc) return normalizedUrl;
    sourceUrl = innerSrc;
  }

  const numericWidth = Number(width) || IMAGE_LOAD_ALLOWED_WIDTHS[0];
  const snappedWidth = IMAGE_LOAD_ALLOWED_WIDTHS.reduce((closest, candidate) =>
    Math.abs(candidate - numericWidth) < Math.abs(closest - numericWidth) ? candidate : closest
  , IMAGE_LOAD_ALLOWED_WIDTHS[0]);

  const params = new URLSearchParams({
    src: sourceUrl,
    w: String(snappedWidth),
    format,
  });
  if (quality) params.set("q", String(quality));

  // elakay_API can be configured with a trailing slash — never emit
  // ".../elakay_api//img-load".
  const apiBase = String(elakay_API).replace(/\/+$/, "");
  return `${apiBase}/img-load?${params.toString()}`;
};

/**
 * Resolves a Category's display image straight from MongoDB -- DB URL first,
 * legacy constructed route only as a last resort. Never wraps the result in
 * getElakayImageLoadUrl(); a caller that wants the resize/webp optimization
 * on top applies it itself (see CardCircle.js), same "resolve, then
 * optionally optimize" split as getProductImageUrls()/getProductPrimaryImage
 * (elakay-utils.jsx) on the product side.
 *
 * image_c and image_r are two distinct presentations (confirmed in
 * server_elakay/elakay_models/category.js + elakay_controllers/category/pub.js):
 *   - image_c ("circle") backs GET /elakay_api/pubCi/:categoryID
 *   - image_r ("rectangle") backs GET /elakay_api/pubR/:categoryID
 * Both share the same Pub sub-schema: `photo`/`imgMobile` (Buffer) are
 * migrated on save into `photoUrl`/`imgMobileUrl` (a persistent
 * /elakay_api/image-assets/:id URL -- the new canonical asset), while
 * `urlImg` is the older self-referencing pubCi/pubR route, which itself
 * 302-redirects to photoUrl when present (see getPubC400X400/getPubR400X400)
 * -- so `photoUrl` is the more direct of the two, not a different image.
 *
 * @param {Object} category a populated category (e.g. product.supCategoryID)
 * @param {Object} options
 * @param {'circle'|'rectangle'} [options.variant='circle']
 * @param {Boolean} [options.mobile=false] prefer imgMobileUrl when present
 * @returns {String|null} a final, directly-loadable URL, or null when this
 *   category has no stored image at all (caller falls back to its own
 *   legacy `${elakay_API}/pubCi|pubR/${categoryId}` construction).
 */
export const resolveCategoryImageUrl = (category, { variant = "circle", mobile = false } = {}) => {
  const imageField = variant === "rectangle" ? category?.image_r : category?.image_c;
  if (!imageField || typeof imageField !== "object") return null;

  const candidates = mobile
    ? [imageField.imgMobileUrl, imageField.photoUrl, imageField.urlImg]
    : [imageField.photoUrl, imageField.urlImg, imageField.imgMobileUrl];

  const stored = candidates.find((url) => typeof url === "string" && url.trim() !== "");
  return stored ? toImageUrl(stored) : null;
};

/**
 * Combine two AnimationSettings color fields into a CSS background style.
 * Only one value set (the other empty/null) -> solid unique color.
 * Both set (and different) -> gradient. Neither set -> undefined, so the
 * caller's own CSS default applies instead of an inline style.
 * @param {String} start
 * @param {String} end
 * @param {Number} angle gradient angle in degrees (default 135)
 */
export const buildGradientOrSolidBackground = (start, end, angle = 135) => {
  const from = start || end;
  const to = end || start;
  if (!from && !to) return undefined;
  return { background: from === to ? from : `linear-gradient(${angle}deg, ${from} 0%, ${to} 100%)` };
};

/**
 * Extract unique values by keyPath from objects array
 * @param {Array} data
 * @param {String} keyPath ex: "addressShop", "categoriesID.catID", "categoriesID.gategoriesLink[0]"
 */

export const extractUnique = (data, keyPath) => {
  const result = new Set();

  data.forEach(item => {
    const value = deepGet(item, keyPath);

    if (Array.isArray(value)) {
      value.forEach(v => result.add(v));
    } else if (value !== undefined && value !== null) {
      result.add(value);
    }
  });

  return [...result];
};

/* smart deep getter */
const deepGet = (obj, path) => {
  try {
    return path
      .replace(/\[(\w+)\]/g, '.$1')
      .replace(/^\./, '')
      .split('.')
      .reduce((o, k) => (o || {})[k], obj);
  } catch {
    return undefined;
  }
};
